import {
  Container,
  Grid,
  Typography,
  useMediaQuery,
} from '@mui/material';
import React from 'react';
import { initMoneyData } from '../../utils/object/Topup';
import styled from 'styled-components';
import { useTheme } from '@mui/styles';

const Button = styled.button`
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #fff;
  color: #1976d2;
  cursor: pointer;
        &:focus {
          background-color: #1976d2;
          color:  #fff;
        }
        &:hover {
          background-color: #1976d2;
          color:  #fff;
        }
   `
const titleStyle = { textAlign: 'center' };
const container = { maxWidth: '600px' };

const CardMoney = () => {
  const value = initMoneyData('', '', '', '', '', '');
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));
  const handleClick = (e) => {
    e.preventDefault();

  }

  return (
    <Container maxWidth="600px" sx={container}>
      <Grid container justifyContent="space-between" alignItems="center" spacing={1} >
        <Grid container item spacing={2}  >
          <Grid item xs={6} lg={3} sx={titleStyle}>
            <Button onClick={handleClick} >
              <Grid sx={{ textAlign: 'center', padding: `${matchDownSM ? '10px' : '20px'}`, width: `${matchDownSM ? '70px' : '100px'}` }}>
                <Typography variant='subtitle1'> {value[10]} </Typography>
              </Grid>
            </Button>
          </Grid>
          <Grid item xs={6} lg={3} sx={titleStyle}>
            <Button onClick={handleClick}  >
              <Grid sx={{ textAlign: 'center', padding: `${matchDownSM ? '10px' : '20px'}`, width: `${matchDownSM ? '70px' : '100px'}` }}>
                <Typography variant='subtitle1'> {value[20]} </Typography>
              </Grid>
            </Button>
          </Grid>
          <Grid item xs={6} lg={3} sx={titleStyle}>
            <Button onClick={handleClick}  >
              <Grid sx={{ textAlign: 'center', padding: `${matchDownSM ? '10px' : '20px'}`, width: `${matchDownSM ? '70px' : '100px'}` }}>
                <Typography variant='subtitle1'> {value[30]} </Typography>
              </Grid>
            </Button>
          </Grid>
          <Grid item xs={6} lg={3} sx={titleStyle}>
            <Button onClick={handleClick}  >
              <Grid sx={{ textAlign: 'center', padding: `${matchDownSM ? '10px' : '20px'}`, width: `${matchDownSM ? '70px' : '100px'}` }}>
                <Typography variant='subtitle1'> {value[50]} </Typography>
              </Grid>
            </Button>
          </Grid>
        </Grid>
        <Grid container item spacing="10px" >
          <Grid item xs={6} lg={3} sx={titleStyle}>
            <Button onClick={handleClick} size={matchDownSM ? 'small' : 'medium'}>
              <Grid sx={{ textAlign: 'center', padding: `${matchDownSM ? '10px' : '20px'}`, width: `${matchDownSM ? '70px' : '100px'}` }}>
                <Typography variant='subtitle1'> {value[100]} </Typography>
              </Grid>
            </Button>
          </Grid>
          <Grid item xs={6} lg={3} sx={titleStyle}>
            <Button onClick={handleClick} >
              <Grid sx={{ textAlign: 'center', padding: `${matchDownSM ? '10px' : '20px'}`, width: `${matchDownSM ? '70px' : '100px'}` }}>
                <Typography variant='subtitle1'> {value[200]} </Typography>
              </Grid>
            </Button>
          </Grid>
          <Grid item xs={6} lg={3} sx={titleStyle}>
            <Button onClick={handleClick} size={matchDownSM ? 'small' : 'medium'}>
              <Grid sx={{ textAlign: 'center', padding: `${matchDownSM ? '10px' : '20px'}`, width: `${matchDownSM ? '70px' : '100px'}` }}>
                <Typography variant='subtitle1'> {value[300]} </Typography>
              </Grid>
            </Button>
          </Grid>
          <Grid item xs={6} lg={3} sx={titleStyle}>
            <Button onClick={handleClick} size={matchDownSM ? 'small' : 'medium'}>
              <Grid sx={{ textAlign: 'center', padding: `${matchDownSM ? '10px' : '20px'}`, width: `${matchDownSM ? '70px' : '100px'}` }}>
                <Typography variant='subtitle1'> {value[500]} </Typography>
              </Grid>
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default CardMoney;
